<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'doctrine.fabric-collection.information'|translate">
      <app-classic-box #classicForm  [classicBox]="classicBox" [data]="lastValue" (changeForm)="enableButton($event)"></app-classic-box>
      <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
        <div class="card-block pull-right">
          <button (click)="submitItem(false)" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button [disabled]="!enableSave"  (click)="submitItem(true)" class="btn btn-primary ripple light" type="button">
              {{(isEdit?'global.save_changes':'global.add')|translate}}
          </button>
        </div>
      </div>
    </app-card>
  </div>
</div>

